import React, { useEffect, useRef } from "react";
import SeoHead from '../component/SeoHead';
import metaData from '../data/Meta.json';
import { jsonLdByPath } from '../data/SchemaTag.js';

export async function getServerSideProps(context) {
    const path = context.resolvedUrl.toLowerCase();

    const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

    const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

    const title = matchedMeta?.title || 'Millance';
    const description = matchedMeta?.description || 'Trade smarter with Millance.';
    const url = matchedMeta?.url || `https://millance.com${path}`;
    const jsonLd = pageJson || null;

    return {
        props: { meta: { title, description, url }, jsonLd, }
    };
}

const Pipcalc = ({ meta, jsonLd }) => {

    const lotsizecalc = useRef();

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://www.cashbackforex.com/Content/remote/remote-widgets.js";
        script.async = false;

        lotsizecalc.current.appendChild(script);

        RemoteCalc({
            Url: "https://www.cashbackforex.com",
            TopPaneStyle: "YmFja2dyb3VuZDogd2hpdGU7IGNvbG9yOiBibGFjazsgYm9yZGVyOiBzb2xpZCAxcHggYmxhY2s7IGJvcmRlci1ib3R0b206IG5vbmU7IA==",
            BottomPaneStyle: "YmFja2dyb3VuZDogd2hpdGU7IGJvcmRlcjogc29saWQgMXB4IGJsYWNrOyBjb2xvcjogYmxhY2s7",
            ButtonStyle: "YmFja2dyb3VuZDogb3JhbmdlOyBjb2xvcjogd2hpdGU7IGJvcmRlci1yYWRpdXM6IDIwcHg7",
            TitleStyle: "dGV4dC1hbGlnbjogbGVmdDsgZm9udC1zaXplOiA0MHB4OyBmb250LXdlaWdodDogNTAwOw==",
            TextboxStyle: "YmFja2dyb3VuZC1jb2xvcjogd2hpdGU7IGNvbG9yOiBibGFjazsgYm9yZGVyOiBzb2xpZCAxcHggI2FhYWFhYQ==",
            ContainerWidth: "900",
            DefaultInstrument: "EUR-USD",
            HighlightColor: "#ffff00",
            IsDisplayTitle: false,
            IsShowChartLinks: false,
            IsShowEmbedButton: false,
            CompactType: "large",
            Calculator: "position-size-calculator",
            ContainerId: "position-size-calculator-345059",
        });
    }, []);


    return (
        <>
            <SeoHead title={meta.title} description={meta.description} jsonLd={jsonLd} url={meta.url} />
            <div className="container-fuild mt-2">
                <section className="mt5trade">
                    <div className="mt5cont">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-md-12 col-lg-6 ">
                                    <h1 className=" mb-2">Forex lot size calculator</h1>
                                    <p className=" mb-3">
                                        Use our lot size calculator to optimize trade volumes and manage risk efficiently. Essential for planning successful forex trades.
                                    </p>
                                </div>
                                <div className="col-md-12 col-lg-6">
                                    <img
                                        src={"/images/main/size.png"}
                                        alt="logo"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="pic-cal">
                    <div id="position-size-calculator-345059" ref={lotsizecalc}></div>
                </div>
            </div>
        </>
    );
};

export default Pipcalc;
